module.exports = __webpack_public_path__ + "img/group.55f42581.svg";